import React, { useEffect, createElement } from 'react';
import { LandingPage } from './pages/LandingPage';
export function App() {
  useEffect(() => {
    const w = window as any;
    if (!w.fbq) {
      const q: any[] = [];
      w.fbq = (...args: any[]) => q.push(args);
      w.fbq.queue = q;
      w.fbq.loaded = true;
      w.fbq.version = '2.0';
      w._fbq = w.fbq;
      const s = document.createElement('script');
      s.async = true;
      s.src = 'https://connect.facebook.net/en_US/fbevents.js';
      const first = document.getElementsByTagName('script')[0];
      if (first && first.parentNode) {
        first.parentNode.insertBefore(s, first);
      } else {
        document.head.appendChild(s);
      }
    }
    w.fbq('init', '1421502962259206');
    w.fbq('track', 'PageView');
  }, []);
  return <LandingPage data-id="element-0" />;
}